/*=========================================================================================
File Name: mutations.js
Description: Vuex Store - mutations
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {
	
	
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////
	
	// Vertical NavMenu
	
	TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
		state.isVerticalNavMenuActive = value
	},
	TOGGLE_REDUCE_BUTTON(state, val) {
		state.reduceButton = val
	},
	UPDATE_MAIN_LAYOUT_TYPE(state, val) {
		state.mainLayoutType = val
	},
	UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
		state.verticalNavMenuItemsMin = val
	},
	UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
		state.verticalNavMenuWidth = width
	},
	
	
	// VxAutoSuggest
	
	UPDATE_STARRED_PAGE(state, payload) {
		
		// find item index in search list state
		const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)
		
		// update the main list
		state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val
		
		// if val is true add it to starred else remove
		if (payload.val) {
			state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
		}
		else {
			// find item index from starred pages
			const index = state.starredPages.findIndex((item) => item.url == payload.url)
			
			// remove item using index
			state.starredPages.splice(index, 1)
		}
	},
	
	// Navbar-Vertical
	
	ARRANGE_STARRED_PAGES_LIMITED(state, list) {
		const starredPagesMore = state.starredPages.slice(10)
		state.starredPages     = list.concat(starredPagesMore)
	},
	ARRANGE_STARRED_PAGES_MORE(state, list) {
		let downToUp                 = false
		let lastItemInStarredLimited = state.starredPages[10]
		const starredPagesLimited    = state.starredPages.slice(0, 10)
		state.starredPages           = starredPagesLimited.concat(list)
		
		state.starredPages.slice(0, 10).map((i) => {
			if (list.indexOf(i) > -1) downToUp = true
		})
		
		if (!downToUp) {
			state.starredPages.splice(10, 0, lastItemInStarredLimited)
		}
	},
	
	
	// ////////////////////////////////////////////
	// UI
	// ////////////////////////////////////////////
	
	TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val   },
	UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val   },
	UPDATE_THEME(state, val)           { state.theme             = val   },
	UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
	UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY           = val   },	
	
	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////
	
	UPDATE_USER_INFO(state, user) {
		// Clear User Object
		localStorage.removeItem('userDetails');
		// Set User Object
		localStorage.setItem('userDetails', JSON.stringify(user));
	},
	CLEAR_USER_INFO() {
		// Clear Access Token
		localStorage.removeItem('accessToken');
		// Clear User Object
		localStorage.removeItem('userDetails');
	},


	// ////////////////////////////////////////////
    // CUSTOM
    // ////////////////////////////////////////////

    // Takedown Domains
    setTakedownDomains: (state, domains) => {
        state.takedownDomains = domains;
    },
    clearTakedownDomains: (state) => {
        state.takedownDomains = [];
    },

    // Listing Count
    setListingTotalCount: (state, count) => {
        state.listingCount['total'] = count;
    },
    setListingFilteredCount: (state, count) => {
        state.listingCount['filtered'] = count;
    },
    clearListingCount: (state) => {
        state.listingCount['total'] = null;
        state.listingCount['filtered'] = null;
    },

    // CNIC Promo Filter
    SET_PROMO_FILTER: (state, filter) => {
        state.promoFilter = filter;
    },
    CLEAR_PROMO_FILTER: (state) => {
        state.promoFilter = null;
    },

    // Table Filter
    setTableFilterValue: (state, value) => {
        state.tableFilter['value'] = value;
    },
    clearTableFilterValue: (state) => {
        state.tableFilter['value'] = null;
    },
    setTableFilterOptions: (state, options) => {
        state.tableFilter['options'] = options;
    },
    clearTableFilterOptions: (state) => {
        state.tableFilter['options'] = null;
    },
    setTableFilterActive: (state) => {
        state.tableFilter['active'] = true;
    },
    clearTableFilterActive: (state) => {
        state.tableFilter['active'] = false;
    },

    // Blacklisted Keywords
    setBlacklistedKeywords: (state, value) => {
        state.blacklistedKeywords = value;
    },
    clearBlacklistedKeywords: (state) => {
        state.blacklistedKeywords = [];
    },

	// Switch to tab on Promo Lists
	setSwitchToTab(state, value) {
		state.switchToTab = value;
	},

	// Master data
	setUsers: (state, value) => {
		state.users = value;
	},
	setAMs: (state, value) => {
		state.ams = value;
	},
	setRoles: (state, value) => {
		state.roles = value;
	},
	setCountries: (state, value) => {
		state.countries = value;
	},
	setCurrencies: (state, value) => {
		state.currencies = value;
	},
	setTlds: (state, value) => {
		state.tlds = value;
	},
	setRegistrars: (state, value) => {
		state.registrars = value;
	},
	setCustomUniqueRegistrars: (state, value) => {
		state.customUniqueRegistrars = value;
	},
	setResellers: (state, value) => {
		state.resellers = value;
	},
	setGroups: (state, value) => {
		state.groups = value;
	},
	setPromoTags: (state, value) => {
		state.promoTags = value;
	},
	setCustomTags: (state, value) => {
		state.customTags = value;
	},
	setClientOptions: (state, value) => {
		state.clientOptions = value;
	},
	setTucowsOnboardingRegistrars: (state, value) => {
		state.tucowsOnboardingRegistrars = value;
	},
	
	setClientRebateStatus: (state, value) => {
		state.clientRebateStatus = value;
	},
	setClientToken: (state, value) => {
		state.clientToken = value;
	},
	setClientAMName: (state, value) => {
		state.clientAMName = value;
	},
	setClientAMEmail: (state, value) => {
		state.clientAMEmail = value;
	},

	setDisableCNICFlag: (state, value) => {
		state.disableCNICFlag = value;
	}
}

export default mutations

